import { ExpoUtils } from '../../expo/utils';
import { ConfirmModal } from './ConfirmModal';
import React, { PropsWithChildren } from 'react';

export const ExternalBrowserDialog = (
  props: { title: string; dialogKey: string | null } & PropsWithChildren
) => {
  const { title, dialogKey, children } = props;
  if (!dialogKey) return null;
  return (
    <ConfirmModal
      key={dialogKey}
      title={title}
      footer={{
        type: 'show',
        applyButton: {
          label: 'Proceed',
          onClick: () => {
            ExpoUtils.sendMessageToExpo({ type: 'open-url-req', url: window.location.href });
          },
        },
        cancelButton: {
          label: 'Cancel',
          onClick: () => {},
        },
      }}
    >
      {children}
    </ConfirmModal>
  );
};
